//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    subtext: {
      type: String,
      default: ''
    }
  },
  methods: {
    subClick: function subClick() {
      this.$emit('subClick');
    }
  }
};